<!-- 制板费明细 -->
<template>
  <div class="price-details">
    <div 
      v-for="(data, type) in list" 
      :key="type" 
      :class="{ 'price-details__content':true, 'multicolumn': col > 1 }"
    >
      <p class="quote-container__right__title">
        {{ type === 'SMT' ? 'SMT加工费明细' : 'PCB制作费明细' }}
      </p>
      <ViewList
        :class="{ 'fpc-tips': isFpcNeedAudit && type === 'FPC' }"
        prefix="￥"
        :emptyText="isFpcNeedAudit && type === 'FPC' ? `软硬结合板暂不支持自动计价\n具体价格以审核为准` : '还未有价格，请填写具体参数'"
        :col="col === 2 ? 1 : 2"
        :data="data"
      />
    </div>
  </div>
</template>

<script>
// 列表展示
import ViewList from '@@/components/viewList/index'

const PRICE_FIELDS = {
  PCB: {
    zkfee: '钻孔费',
    gch: '工程费',
    clc: '板材费',
    specificfee: '指定板材费',
    banfee: '特殊板厚',
    plate: '菲林费',
    pin: '拼版费',
    copperfee: '铜厚费',
    populerfee: '冷门工艺费',
    difficultyfee: '难度工艺费',
    pthfee: 'PTH孔费',
    sprayfee: 'OSP',
    cjfee: '超沉金费',
    coverfee: '阻焊覆盖费',
    colorfee: '颜色费',
    pthfee: 'PTH孔费',
    bgafee: 'BGA费',
    viasfee: '过孔费',
    impendancefee: '阻抗费',
    bankongfee: '半孔包边费',
    blindfee: 'HDI(盲埋孔)费',
    testfee: '测试费',
    reportfee: '报告费',
    extraurgentfee: '加急费',
    viainpadfee: '盘中孔费',
    pressingfee: '叠层结构费',
    crossfee: '打叉板费',
    paperfee: '隔白纸费',
    userstampfee: '不加客编费',
    scatterfee: '小板费',
  },
  FPC: {
    gch: '工程费',
    clc: '板材费',
    pin: '拼版费',
    copperfee: '铜厚费',
    colorfee: '颜色费',
    sprayfee: '喷镀费（沉金费/电金费）',
    reinforcefee: '补强费',
    backgumfee: '背胶费',
    elecmemfee: '电磁膜费',
    condresinfee: '导电胶费',
    formingfee: '成型费',
    impendancefee: '阻抗费',
    extraurgentfee: '加急费',
    crossfee: '打叉板费',
    testfee: '测试费',
    reportfee: '报告费',
  },
  SMT: {
    total_project_fee_no_tax: '工程费',
    sum_smt_price_no_tax: '贴片费',
    sum_dip_price_no_tax: '插件费',
    sum_spec_price_no_tax: '特殊工艺费',
    other_price_no_tax: '其他'
  }
}

export default {
  props: {
    type: {
      type: String,
      validator: function (value) {
        return ['PCB', 'FPC', 'SMT', 'PCB_SMT', 'FPC_SMT', 'SMT_PCB', 'SMT_FPC'].includes(value)
      }
    },
    pcbPrice: {
      type: Object,
      default: () => ({})
    },
    smtPrice: {
      type: Object,
      default: () => ({})
    },
    // 表面处理
    spray: {
      type: String,
      default: ''
    },
    isFpcNeedAudit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ViewList
  },
  computed: {
    col() {
      return this.type.split('_').length
    },
    list() {
      const { type, isFpcNeedAudit } = this
      const types = type.split('_')
      // PCB/FPC排前面
      return ['PCB', 'FPC', 'SMT']
        .filter(i => types.includes(i))
        .reduce((data, type) => {
          data[type] = isFpcNeedAudit && type === 'FPC' ? [] : this.getList(type)
          return data
        }, {})
    }
  },
  methods: {
    getList(type) {
      const { pcbPrice, smtPrice, spray } = this
      const data = type === 'SMT' ? smtPrice : pcbPrice
      const fields = PRICE_FIELDS[type]
      return Object.keys(fields)
        .filter(key => data[key] && data[key] > 0)
        .map(key => {
          let label = fields[key]
          if (key === 'sprayfee') {
            label = `${spray === 'OSP' ? 'OSP' : spray.substring(0, 2)}费`
          }
          return { label, value:  data[key] }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.price-details {
  display: flex;
  >div + div {
    margin-left: 6px;
  }
  .price-details__content {
    flex: 1;
    &.multicolumn {
      width: calc(50% - 3px);
      .view-list {
        min-height: calc(100% - 35px);
        background-color: $--background-base;
      }
    }
  }
  .fpc-tips {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
}
</style>